import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";
 //#region comment metod

 const PostUpdateStorePickup = (data: any): Promise<any>  =>
 request({
   url: ApiURL.Command.PostUpdateStorePickup,
   method: RequestType.POST,
   data,
 });

 const PostUpsertStoreCapacity = (data: { storeCode: string; capacity: number }): Promise<any> =>
 request({
   url: ApiURL.Command.PostUpsertStoreCapacity,
   method: RequestType.POST,
   data,
 });
 const PostUpdateStoreList = (data: any): Promise<any>  =>
 request({
   url: ApiURL.Query.UpdateStoreList,
   method: RequestType.POST,
   data,
 }); 
 const PostServiceManagment = (data: any): Promise<any>  =>
 request({
   url: ApiURL.Command.PostUpdateServieceManagment,
   method: RequestType.POST,
   data,
 }); 
 
 const SaveOperationFlagValue = (data: any): Promise<any>  =>
 request({
   url: ApiURL.Command.SaveOperationFlagValue,
   method: RequestType.POST,
   data,
 }); 

 const OmnichannelCommand = {
  PostUpdateStorePickup,
  PostUpsertStoreCapacity,
  PostUpdateStoreList,
  PostServiceManagment,
  SaveOperationFlagValue,
  };
  
  export default OmnichannelCommand;